"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountCodeScope = void 0;
var DiscountCodeScope;
(function (DiscountCodeScope) {
    DiscountCodeScope["Season"] = "Season";
    DiscountCodeScope["Global"] = "Global";
})(DiscountCodeScope = exports.DiscountCodeScope || (exports.DiscountCodeScope = {}));
//# sourceMappingURL=discount-code-scope.js.map